import { modelRequest } from '@stem-sims/nexus'
import { StateResponse } from '../types/accountTypes'

export function get(country: string): Promise<StateResponse[]> {
    return modelRequest.get("/api/states?country=" + country)
}
